// Alignment classes aren't added anymore, but they're needed for
// backward compatibility unless we run a migration.
export const quillStyles = `
.ql-align-right {
  text-align: right;
}
.ql-align-center {
  text-align: center;
}
.ql-size-small {
  font-size: 0.75em
}
.ql-size-large {
  font-size: 1.5em
}
.ql-size-huge {
  font-size: 2.5em
}
.ql-blank {
  padding: unset !important;
}
.ql-blank::before {
  left: unset !important;
  right: unset !important;
}`;
